'use client';

import { isBusinessUatCookieSet, matchesRoutePath, ROUTES, toLegacyRelativePath, useClientConfig } from '@shared/utils';
import { useEffect } from 'react';

const LEGACY_ROUTES = [ROUTES.FOOTER?.NAVIGATION?.LOTTERY?.RESULTS, ROUTES.FOOTER?.NAVIGATION?.LOTTERY?.SYNDICATES, ROUTES.BETCLUB].filter(Boolean) as string[];

function LegacyRouteInterceptor(): null {
  const { legacySiteUrl } = useClientConfig();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const handler = (ev: MouseEvent) => {
      const target = ev.target as HTMLElement | null;
      const anchor = target?.closest?.('a[href]') as HTMLAnchorElement | null;
      if (!anchor) return;

      const relativeHref = toLegacyRelativePath(anchor.getAttribute('href') || '', legacySiteUrl, window.location.origin);
      if (!relativeHref) return;

      // Match on the pathname only: the query string and hash are ignored for matching but kept in the dispatched href.
      const [pathname = relativeHref] = relativeHref.split(/[?#]/);
      const isScratchcards = !isBusinessUatCookieSet() && matchesRoutePath(pathname, ROUTES.SCRATCHCARDS.DISCOVERY);
      const isLegacyRoute = LEGACY_ROUTES.some(route => matchesRoutePath(pathname, route));

      if (isScratchcards || isLegacyRoute) {
        ev.preventDefault();
        window.dispatchEvent(new CustomEvent('legacy:open', { detail: { href: relativeHref } }));
      }
    };

    document.addEventListener('click', handler, { capture: true });
    return () => document.removeEventListener('click', handler, { capture: true });
  }, [legacySiteUrl]);

  return null;
}

export { LegacyRouteInterceptor };
